import Cookie from 'js-cookie';

const cookieService = {
  getXsrfToken() {
    return Cookie.get('XSRF-TOKEN');
  }
};

export default cookieService;
